module.exports = "pegasus_template/assets/blocks/capture-8-basic.png";